import api from './api';

export const SpecialistsAPI = {
  getAll: (params = {}) => api.get('/api/v1/specialists', { params }),
  getOne: (id) => api.get(`/api/v1/specialists/${id}`),
  create: (data) => api.post('/api/v1/specialists', data),
  update: (id, data) => api.put(`/api/v1/specialists/${id}`, data),
  delete: (id) => api.delete(`/api/v1/specialists/${id}`),
  search: (query) => api.get('/api/v1/specialists/search', { params: { query } }),
  getByService: (service) => api.get('/api/v1/specialists/service', { params: { service } }),
};